import classnames from 'classnames';
import styles from './styles.module.less';

const LayerResizeAction = () => {
    const backSlashCursorArr = [3, 0, 1, 2];

    return (
        <div className="l-cropImage-resizeAction-img">
            <span>
                <div
                    className={classnames('resize tc', {
                        [styles[`scale-${backSlashCursorArr[1]}`]]: true,
                    })}
                    data-operate-type="crop-layer-resize-tc"
                />
                <div
                    className={classnames('resize bc', {
                        [styles[`scale-${backSlashCursorArr[1]}`]]: true,
                    })}
                    data-operate-type="crop-layer-resize-bc"
                />
            </span>

            <span>
                <div
                    className={classnames('resize lc', {
                        [styles[`scale-${2}`]]: true,
                    })}
                    data-operate-type="crop-layer-resize-lc"
                />
                <div
                    className={classnames('resize rc', {
                        [styles[`scale-${2}`]]: true,
                    })}
                    data-operate-type="crop-layer-resize-rc"
                />
            </span>
        </div>
    );
};

export default LayerResizeAction;
